var indexOf = [].indexOf;

import humanize from 'helpers/humanize';

import random from 'helpers/random';

angular.module('gym.components').directive('editReportFilters', function() {
  return {
    restrict: 'E',
    template: require('templates/components/reports/edit_report_filters.html.slim'),
    scope: {
      report: '=',
      reports: '='
    },
    controller: ["$rootScope", "$scope", "$filter", "$modal", "Reports", "MessageService", function($rootScope, $scope, $filter, $modal, Reports, MessageService) {
      var inReportOptions, relativeDateReady, userValueReady;
      $scope.inReportFilterAvailable = $rootScope.gym.gym_config.can_use_in_other_report_filters;
      $scope.relativeDateId = random();
      inReportOptions = [
        {
          label: 'Is in other report',
          operator: 'IN REPORT',
          inReport: true
        },
        {
          label: 'Is not in other report',
          operator: 'NOT IN REPORT',
          inReport: true
        }
      ];
      $scope.periods = ['days', 'weeks', 'months', 'years'];
      $scope.multipliers = ['from_now', 'ago'];
      $scope.addFilter = function(filter) {
        var base, report_filter;
        (base = $scope.report).report_filters_attributes || (base.report_filters_attributes = []);
        report_filter = filter.column.inReport ? {
          operator: filter.column.operator,
          operator_label: humanize(filter.column.operator),
          user_value: filter.user_value,
          database_value_label: 'Contact',
          database_value: 'contacts:id'
        } : {
          database_value: filter.column.form_field_id || filter.column.table_and_column || filter.column.unique_id,
          database_value_label: filter.column.label,
          data_type: filter.column.data_type,
          operator: filter.condition[1],
          operator_label: filter.condition[0],
          user_value: filter.user_value,
          relative_date: filter.relative_date,
          multiplier: filter.multiplier,
          period: filter.period,
          number: filter.number
        };
        $scope.newFilter = {};
        return $scope.report.report_filters_attributes.push(report_filter);
      };
      $scope.deleteFilter = function(filter, index) {
        if (filter.id) {
          return filter._destroy = 1;
        } else {
          return $scope.report.report_filters_attributes.splice(index, 1);
        }
      };
      $scope.onEditFilter = function(filter, index) {
        var modalInstance;
        modalInstance = $modal.open({
          template: require('templates/components/reports/manage_filter_conditions.html.slim'),
          controller: 'ManageFilterConditionsCtrl',
          size: 'md',
          resolve: {
            report: function() {
              return $scope.report;
            },
            reports: function() {
              return $scope.reports;
            },
            inReportOptions: function() {
              return inReportOptions;
            },
            inReportFilterAvailable: function() {
              return $scope.inReportFilterAvailable;
            },
            displayInReportFilterDescription: function() {
              return $scope.displayInReportFilterDescription;
            },
            filter: function() {
              return angular.extend({}, filter);
            }
          }
        });
        return modalInstance.result.then(function(data) {
          return $scope.report.report_filters_attributes[index] = data;
        });
      };
      $scope.onRelativeChange = function() {
        var base, base1;
        if ($scope.newFilter.relative_date) {
          $scope.newFilter.user_value = '';
          (base = $scope.newFilter).relative_date || (base.relative_date = false);
          (base1 = $scope.newFilter).multiplier || (base1.multiplier = $scope.multipliers[0]);
          return $scope.newFilter.period = 'months';
        }
      };
      $scope.appliedFiltersCount = function() {
        var filters;
        filters = _.filter($scope.report.report_filters_attributes, function(filter) {
          return filter._destroy !== 1;
        });
        return filters.length;
      };
      $scope.displayInReportFilterDescription = function() {
        return MessageService.message({
          title: 'Using "Is in / Is not in other report" filters',
          message: ['Please be aware that the "Is in other report" / "Is not in other report" filters rely on data that is refreshed frequently, but may not always be 100% up to date.', 'Because of this, there may be a short period after a contact has entered or left the other report, where these filters can return inaccurate results.'],
          confirmButtonText: 'Ok'
        });
      };
      $scope.displaySectionName = function(section) {
        return $scope.report.column_section_name_map[section] || humanize(section);
      };
      $scope.availableColumns = function() {
        var available, availableColumns, columns, forbiddenForFiltration, ref, ref1, ref2;
        columns = (ref = $scope.report.report_columns_options) != null ? ref[(ref1 = $scope.newFilter) != null ? ref1.section : void 0] : void 0;
        forbiddenForFiltration = ['Contact ID'];
        available = _.filter(columns, function(column) {
          var ref2;
          return ref2 = column.label, indexOf.call(forbiddenForFiltration, ref2) < 0;
        });
        availableColumns = _.map(available, function(val) {
          return val;
        });
        if ($scope.inReportFilterAvailable && ((ref2 = $scope.newFilter) != null ? ref2.section : void 0) === 'contact') {
          return inReportOptions.concat(availableColumns);
        } else {
          return availableColumns;
        }
      };
      $scope.onColumnChanged = function() {
        $scope.newFilter.condition = '';
        return $scope.newFilter.relative_date = false;
      };
      $scope.onConditionChanged = function() {
        $scope.newFilter.user_value = '';
        $scope.newFilter.number = '';
        $scope.newFilter.relative_date = false;
        $scope.newFilter.multiplier = '';
        return $scope.newFilter.period = '';
      };
      $scope.requireUserValue = function() {
        var blankValueConditions, ref, ref1, ref2;
        blankValueConditions = ['Is blank', 'Is not blank'];
        return ref = (ref1 = $scope.newFilter) != null ? (ref2 = ref1.condition) != null ? ref2[0] : void 0 : void 0, indexOf.call(blankValueConditions, ref) < 0;
      };
      relativeDateReady = function() {
        var filter;
        filter = $scope.newFilter;
        return filter.relative_date && (($filter('filterInt')(filter.number) >= 0) && filter.period && filter.multiplier);
      };
      userValueReady = function() {
        var ref;
        return !$scope.requireUserValue() || ((ref = $scope.newFilter.user_value) != null ? ref.toString() : void 0) || relativeDateReady();
      };
      return $scope.isFilterReady = function() {
        var ref, ref1, ref2;
        if ((ref = $scope.newFilter) != null ? (ref1 = ref.column) != null ? ref1.inReport : void 0 : void 0) {
          return userValueReady();
        } else {
          return ((ref2 = $scope.newFilter) != null ? ref2.column : void 0) && $scope.newFilter.condition && userValueReady();
        }
      };
    }]
  };
});
